<template>
  <div
    v-if="incidents.length"
    class="pr-2"
  >
    <request-incident-card
      v-for="incident in incidents"
      :key="incident.incidentId"
      :incident="incident"
    />
  </div>
</template>

<script>
import RequestIncidentCard from '@/components/IncidentCard'
import incidentServices from '@/api/resources/incident/incidentServices'

export default {
    name: 'RequestIncidentsInfo',
    components: {
        RequestIncidentCard
    },
    props: {
        requestId: { type: Number, required: true },
        labId: { type: Number, required: true }
    },
    data() {
        return {
            incidents: []
        }
    },
    async created() {
        const [err, response] = await this.toCall(incidentServices.getRequestIncidents(this.labId, this.requestId))
        if (err) {
            this.showErrorModalGlobal()
            return
        }
        this.incidents = response
    }
}

</script>
